import { render, staticRenderFns } from "./CartGoal.vue?vue&type=template&id=12d877d3&"
import script from "./CartGoal.vue?vue&type=script&lang=js&"
export * from "./CartGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports